var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"arrow-left"},React.createElement("path",{"id":"arrow left","fillRule":"evenodd","clipRule":"evenodd","d":"M9.70711 18.7071C10.0976 18.3166 10.0976 17.6834 9.70711 17.2929L5.41421 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H5.41421L9.70711 6.70711C10.0976 6.31658 10.0976 5.68342 9.70711 5.29289C9.31658 4.90237 8.68342 4.90237 8.29289 5.29289L2.29289 11.2929C2.10983 11.476 2.01258 11.7123 2.00114 11.952C2.00038 11.968 2 11.984 2 12M2.07588 12.3828C2.12468 12.5007 2.19702 12.6112 2.29289 12.7071L8.29289 18.7071C8.68342 19.0976 9.31658 19.0976 9.70711 18.7071M2.00004 12.0092C2.00124 12.1415 2.0281 12.2676 2.07588 12.3828L2.00004 12.0092Z","fill":"currentColor"})));
}

BackArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
